import '../../styles/TitleBar.scss'
import React, { useState, useCallback, useEffect } from 'react'
import { DropdownButton, Dropdown, ButtonToolbar, Button, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { itemType } from '../../types'
import { isEmpty } from 'lodash'
import FileListChange from '../FileListChange'
import DeleteItem from '../DeleteItem'
import CancelFileChangeModal from '../CancelFileChangeModal'
import S3FileuploadModal from '../S3FileuploadModal'
import S3GroupFileDownloadModal from '../S3GroupFileDownloadModal'
import GroupFilePublishModal from '../GroupFilePublishModal'
import FileUploadUppyModal from '../FileUploadUppyModal'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/progress-bar/dist/style.css'
import '@uppy/status-bar/dist/style.css'
import PropTypes from 'prop-types'
import { useMutation } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import { FRAGMENTS_FILE } from '../../utils/graphqlFragments'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CREATE_ITEM_FILES_QUERY = gql`
    ${FRAGMENTS_FILE}
    mutation createItemFiles($input: ItemFileInput) {
      createItemFiles(input: $input) {
        ... fileFields
      }
    }
`
export default function TitleBar({ item, selectedRows, resetSelectedRows }) {
  const [showChangeModal, setShowChangeModal] = useState(false)
  const [show, setShow] = useState(false)
  const [showProcess, setShowProcess] = useState(false)
  const [showS3, setShowS3] = useState(false)
  const [showDownload, setShowDownload] = useState(false)
  const [showGroupPublish, setShowGroupPublish] = useState(false)
  const reload = () => window.location.reload()
  const [uppyOpen, setUppyOpen] = useState(false)
  const [fileInputs, setFileInputs] = useState(false)

  const handleClose = () => {
    setShow(false)
    reload()
  }

  const setReturnInputs = useCallback(
    (returnFiles) => {
      setFileInputs(returnFiles)
    },
    [],
  )
  const setUppyOpenCallback = useCallback(
    (uppystatus) => {
      setUppyOpen(uppystatus)
      if (!uppystatus) {
        handleClose()
      }
    },
    // eslint-disable-next-line
    [],
  )

  const [createItemFiles, { data, loading }] = useMutation(
    CREATE_ITEM_FILES_QUERY)
  useEffect(() => {
    if (!isEmpty(fileInputs)) {
      createItemFiles({
        variables: {
          input: { uploadStatus: 'Upload', itemFiles: fileInputs }
        }
      })
      setFileInputs([])
    }

  }, [fileInputs, createItemFiles])

  useEffect(() => {
    if (loading) {
      setShowProcess(true)
    } else {
      setShowProcess(false)
      setFileInputs([])
    }
  }, [loading, data])

  const itemId = item.id
  const canWrite = get(item, 'permissions.currentUser.canWrite', false)
  const fileuploadLimit = Number(process.env.REACT_APP_FILE_UPLOAD_LIMIT)
  const uploadLimitMessageHeader = 'A problem was encountered.'
  const uploadLimitMessage = `The file attachment limit was exceeded. Items have a limit of ${fileuploadLimit} attached files. This item can accommodate {0} additional file(s).`

  const redirect = () => {
    let url = process.env.REACT_APP_CATALOG_URI + '/item/' + itemId + '?a=' + new Date().getTime()
    window.location.replace(url)
  }
  function redirectOrShowChangeModal() {
    if (selectedRows.length <= 0) {
      redirect()
    } else {
      setShowChangeModal(true)
    }
  }

  if (isEmpty(item)) return null

  function returnToCatalogButton() {
    return (
      <Button variant='primary' onClick={(e) => {
        e.preventDefault()
        redirectOrShowChangeModal()
      }}>Return to Item</Button>
    )
  }

  return (
    <div id='sb-title-bar-container'>
      <div id='sb-item-titlebar'>
        <div className='title-bar-menus pull-right'>

          <ButtonToolbar>
            {returnToCatalogButton()}
            {<DeleteItem item={item} canWrite={canWrite} />}
            {<FileListChange fileLength={item.fileConnection.files.length} selectedRows={selectedRows} resetSelectedRows={resetSelectedRows} />}
            {canWrite ?
              <>
                <DropdownButton
                  variant='secondary'
                  alignright='true'
                  className='title-bar-dropdown'
                  id='add-menu'
                  title='Add'>
                  <Dropdown.Item onClick={() => setUppyOpen(true)} > Upload Files</Dropdown.Item>
                  <Dropdown.Item onClick={() => setShowS3(true)} > Upload S3 Files</Dropdown.Item>
                </DropdownButton>
                <div><Button onClick={() => setShowDownload(true)} alignright="true" variant="secondary" id="add-menu">S3 Bulk Download</Button></div>
                <div>&nbsp;<Button onClick={() => setShowGroupPublish(true)} alignright="true" variant="secondary" id="add-menu">Batch Publish</Button></div>
              </>
              : <div>&nbsp;<Button onClick={() => setUppyOpen(true)} alignright="true" variant="secondary" id="add-menu">Upload Files</Button></div>

            }
          </ButtonToolbar>
          <CancelFileChangeModal show={showChangeModal} selectedRows={selectedRows} onHide={() => { setShowChangeModal(false) }} onClear={() => {
            resetSelectedRows()
          }} />
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>File Upload Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Files uploaded will be scraped and will appear once scraped
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={showProcess} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>File Upload Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <span ><FontAwesomeIcon icon={faSpinner} pulse /> &nbsp;Processing data, please do not refresh page.</span>
            </Modal.Body>

          </Modal>
          <FileUploadUppyModal
            setShow={setShow}
            item={item}
            isOverwriteInfoSeen={false}
            itemFilesCount={item.fileConnection.files.length}
            fileUploadLimit={fileuploadLimit}
            uploadLimitMessageHeader={uploadLimitMessageHeader}
            uploadLimitMessage={uploadLimitMessage}
            open={uppyOpen}
            setUppyOpen={setUppyOpenCallback}
            setReturnInputs={setReturnInputs}
          />
          <S3FileuploadModal
            key={itemId + '_upload_modal'}
            show={showS3}
            onHide={() => {
              setShowS3(false)
              reload()
            }}
            item={item}
            itemFilesCount={item.fileConnection.files.length}
            fileUploadLimit={fileuploadLimit}
            uploadLimitMessageHeader={uploadLimitMessageHeader}
            uploadLimitMessage={uploadLimitMessage}
          />
          <S3GroupFileDownloadModal
            show={showDownload}
            key={itemId + '_download_modal'}
            onHide={() => {
              setShowDownload(false)
            }}
            size='lg'
            item={item}
            itemId={itemId}
          />
          <GroupFilePublishModal
            show={showGroupPublish}
            key={itemId + '_group_publish_modal'}
            onHide={() => {
              setShowGroupPublish(false)
              reload()
            }}
            size='lg'
            item={item}
            itemId={itemId}
          />
        </div>
        <header>
          <h1><Link to={`/item/${item.id}`}>{item.title}</Link></h1>
          <br />
          <br />
          <h4><span className='text-secondary font-weight-bold'><font color='#2471A3'>{item.fileConnection.files.length} Attached files</font></span></h4>
          {(item.subTitle) ?
            <div id="subtitle-container">
              <span className="sb-subtitle">{item.subTitle}</span>
            </div>
            : ''}
        </header>
      </div>
    </div>
  )
}

TitleBar.propTypes = {
  item: itemType,
  selectedRows: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
      map: PropTypes.func
    })
  ),
  resetSelectedRows: PropTypes.any
}
